import { useApolloClient } from "@apollo/client";
import { Box, Grid, List, ListItem, Typography } from "@mui/material";
import React from 'react';
import { DocumentViewer } from "../../../components/fileViewer/index";
import { GET_ASSET_MASTER } from "../../../graphql/queries";
import { unitStyles } from "../style";
import { assestType } from '../../../utils/common'
import NoDataFound from "../../../assets/noData";
export const Assets = (props) => {
    const classes = unitStyles()
    const [value, setValue] = React.useState(2);
    const [listing, setlisting] = React.useState([])
    const client = useApolloClient();
    React.useEffect(() => {
        client.query({
            query: GET_ASSET_MASTER,
            fetchPolicy: 'network-only',

        }).then((res) => {
            setlisting(res.data?.assets_master)
        })
        // eslint-disable-next-line
    }, [])

    const handleList = (val) => {
        setValue(val);
    };
    const getVideoId = (url) => {
        const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        const match = url?.match(regExp);

        return (match && match[2].length === 11)
            ? match[2]
            : null;
    }
    return (
        <Box className={classes.imagebox1} >
            <>

                <List style={{ display: 'flex' }} className={classes.list}>

                    {
                        listing.filter(x => x?.id !== assestType?.Thumbnails).map((val) => {

                            return (
                                <ListItem className={val.id === value ? classes.listText : classes.list}
                                    onClick={() => handleList(val.id)}
                                >
                                    <Typography className={classes.tabname}>{val.type}</Typography>
                                </ListItem>
                            )
                        })
                    }
                </List>
                <div style={{ marginTop: "8px" }}>
                {
                    props?.asset?.filter((i)=> i?.asset_type === value)?.length ?
                    <Grid container >
                        {
                            props?.asset?.filter(x => x?.id !== assestType?.Thumbnails).map((val) => {
                                const url = getVideoId(val.url)

                                return (
                                    <>
                                        {
                                            val?.asset_type === value &&

                                            <Grid item xs={2} style={{ margin: "4px", borderRadius: "12px", overflow: "hidden" }}>

                                                {
                                                    val?.asset_type === assestType?.Documents ?
                                                        <div style={{ height: "150px", overflow: "auto" }}>
                                                            <DocumentViewer url={val?.url} />
                                                        </div>
                                                        :
                                                        <>
                                                            {
                                                                val?.asset_type === assestType?.Videos ?
                                                                    <iframe
                                                                        title={val?.file_meta?.name}
                                                                        className={classes.video}
                                                                        src={"https://www.youtube.com/embed/" + url}>
                                                                    </iframe>
                                                                    // <video
                                                                    //     style={{
                                                                    //         objectFit: "cover",
                                                                    //         height: "150px",
                                                                    //         width: "100%",
                                                                    //         borderRadius: "12px",
                                                                    //     }}
                                                                    //     controls
                                                                    // >
                                                                    //     <source src={val.url} type="video/mp4" />
                                                                    // </video>
                                                                    : <img
                                                                        src={val.url}
                                                                        alt=""
                                                                        style={{
                                                                            objectFit: "cover",
                                                                            height: "150px",
                                                                            width: "100%",

                                                                        }}
                                                                    />
                                                            }
                                                        </>

                                                }

                                            </Grid>
                                        }
                                    </>
                                )
                            })
                        }

                    </Grid>
                    : <Box display={"flex"} alignItems={"center"} justifyContent={"center"}><NoDataFound /></Box>}
                </div>
            </>
        </Box>
    )
}